import { useState, type FormEvent } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";

const navItems = [
  { label: "首页", to: "/" },
  { label: "电影", to: "/category/movie" },
  { label: "电视剧", to: "/category/tv" },
  { label: "综艺", to: "/category/variety" },
  { label: "搜索", to: "/search" },
  { label: "关于", to: "/about" },
];

export default function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [keyword, setKeyword] = useState("");
  const navigate = useNavigate();

  const handleSearch = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const value = keyword.trim();
    navigate(value ? `/search?q=${encodeURIComponent(value)}` : "/search");
    setMenuOpen(false);
  };

  return (
    <header className="sticky top-0 z-50 w-full border-b border-background-200/80 bg-background-50/95 backdrop-blur">
      <div className="mx-auto flex h-16 w-full max-w-[1320px] items-center gap-4 px-4 md:px-6">
        <Link to="/" className="flex items-center gap-2.5 shrink-0">
          <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
            <i className="ri-mickey-fill text-lg" />
          </span>
          <span className="font-heading text-lg font-extrabold tracking-tight text-foreground-950">
            蘑菇<span className="text-primary-600">视频</span>
          </span>
        </Link>

        <nav className="ml-4 hidden items-center gap-1 md:flex">
          {navItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.to === "/"}
              className={({ isActive }) =>
                `rounded-md px-3.5 py-2 text-sm font-medium transition-colors whitespace-nowrap ${
                  isActive
                    ? "bg-primary-100 text-primary-700"
                    : "text-foreground-700 hover:bg-background-100 hover:text-foreground-950"
                }`
              }
            >
              {item.label}
            </NavLink>
          ))}
        </nav>

        <form
          onSubmit={handleSearch}
          className="ml-auto hidden items-center gap-2 rounded-full border border-background-200 bg-background-100 px-3 py-1.5 lg:flex"
        >
          <i className="ri-search-line text-base text-foreground-400" />
          <input
            value={keyword}
            onChange={(e) => setKeyword(e.target.value)}
            placeholder="搜索电影、电视剧、综艺"
            className="w-44 bg-transparent text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none"
          />
          <button
            type="submit"
            className="cursor-pointer whitespace-nowrap rounded-full bg-primary-500 px-3 py-1 text-xs font-medium text-background-50 transition-colors hover:bg-primary-600"
          >
            搜索
          </button>
        </form>

        <Link
          to="/search"
          className="ml-auto flex h-9 w-9 items-center justify-center rounded-full bg-background-100 text-foreground-700 lg:hidden"
          aria-label="搜索"
        >
          <i className="ri-search-line text-lg" />
        </Link>

        <button
          type="button"
          onClick={() => setMenuOpen((v) => !v)}
          className="flex h-9 w-9 items-center justify-center rounded-md text-foreground-800 md:hidden"
          aria-label="菜单"
        >
          <i className={menuOpen ? "ri-close-line text-xl" : "ri-menu-line text-xl"} />
        </button>
      </div>

      {menuOpen && (
        <div className="border-t border-background-200 bg-background-50 px-4 pb-4 pt-3 md:hidden">
          <div className="grid grid-cols-2 gap-2">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.to === "/"}
                onClick={() => setMenuOpen(false)}
                className={({ isActive }) =>
                  `rounded-lg px-3 py-2.5 text-sm font-medium ${
                    isActive
                      ? "bg-primary-100 text-primary-700"
                      : "bg-background-100 text-foreground-700"
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
          </div>
          <form
            onSubmit={handleSearch}
            className="mt-3 flex items-center gap-2 rounded-full border border-background-200 bg-background-100 px-4 py-2"
          >
            <i className="ri-search-line text-base text-foreground-400" />
            <input
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              placeholder="搜索影视内容"
              className="w-full bg-transparent text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none"
            />
          </form>
        </div>
      )}
    </header>
  );
}